import { Stack } from "@mui/material";
import React from "react";

import { Chip } from "..";

export const SecondaryTabs = <T extends { displayName: string; name: string; onClick?: () => void }>({
  activeTab,
  handleTabChange,
  tabs,
}: {
  activeTab: T;
  handleTabChange: (tab: T) => void;
  tabs: T[];
}) => {
  return (
    <Stack className="gap-2">
      {tabs.map((tab) => {
        return (
          <Chip
            isOn={activeTab === tab}
            key={tab.name}
            onClick={() => {
              handleTabChange(tab);
              tab.onClick?.();
            }}
          >
            {tab.displayName ?? tab.name}
          </Chip>
        );
      })}
    </Stack>
  );
};
